module.exports = __webpack_public_path__ + "static/media/winner.271d9901.svg";